import { render, staticRenderFns } from "./TheMainFooter.vue?vue&type=template&id=d9edf502&scoped=true"
import script from "./TheMainFooter.vue?vue&type=script&lang=js"
export * from "./TheMainFooter.vue?vue&type=script&lang=js"
import style0 from "./TheMainFooter.vue?vue&type=style&index=0&id=d9edf502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9edf502",
  null
  
)

export default component.exports